import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ReportByDateEntity } from '../../../data/repositories/consult/entities/report-by-date.entity';
import { ConsultRepository } from '../../repositories/consult.repository';

export class GetAttentionReportByDateUseCase implements UseCase<{DateInit: Date,DateEnd:Date, IdEmpresa:string}, ReportByDateEntity> {
    constructor(private ConsultRepository: ConsultRepository) { }
    execute(
        params: {DateInit: Date,DateEnd:Date, IdEmpresa:string},
    ): Observable<ReportByDateEntity> {
        return this.ConsultRepository.getAttentionReportByDate(params);
    }
}
